import { SET_MAIN_PAGE_CONTENT, SET_POSTS_CONTENT, ADD_POST_FIELD, DELETE_POST_FIELD, CLEAN_FIELDS } from '../../constants/templateGenerator';

const initialState = {
    mainPageContent: '',
    posts: ['']
};

const templateGeneratorReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MAIN_PAGE_CONTENT:
            return { ...state, mainPageContent: action.payload };
        case SET_POSTS_CONTENT:
            const newPostsData = state.posts;
            newPostsData[action.postIndex] = action.payload
            return { ...state, posts: newPostsData }
        case ADD_POST_FIELD:
            return { ...state, posts: [ ...state.posts, ''] }
        case DELETE_POST_FIELD:
            if(state.posts.length <= 1) return state;
            return { ...state, posts: state.posts.slice(0, -1) }
        case CLEAN_FIELDS:
            return { mainPageContent: '', posts: [''] }
        default:
            return state;
    }
}

export default templateGeneratorReducer;